function getDateAsIsoString(date) {
    const month = date.getMonth() + 1;
    let monthStr = month.toString();
    if (monthStr.length === 1) {
        monthStr = `0${monthStr}`;
    }
    let dayStr = `${date.getDate()}`;
    if (dayStr.length === 1) {
        dayStr = `0${dayStr}`;
    }
    return `${date.getFullYear()}-${monthStr}-${dayStr}`;
}

function parseAppointmentDate (value) {
    if (!value || typeof value !== 'string') return null;

    const months = {
        // FR
        janvier: 0,
        février: 1,
        fevrier: 1,
        mars: 2,
        avril: 3,
        mai: 4,
        juin: 5,
        juillet: 6,
        août: 7,
        aout: 7,
        septembre: 8,
        octobre: 9,
        novembre: 10,
        décembre: 11,
        decembre: 11,

        // EN
        january: 0,
        february: 1,
        march: 2,
        april: 3,
        may: 4,
        june: 5,
        july: 6,
        august: 7,
        september: 8,
        october: 9,
        november: 10,
        december: 11,
    };

    const normalizedValue = value
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

    const match = normalizedValue.match(/(\d{1,2})\s+([a-z]+)\s+(\d{4})/);

    if (!match) return null;

    const [, day, monthName, year] = match;
    const monthIndex = months[monthName];

    if (monthIndex === undefined) return null;

    return new Date(Number(year), monthIndex, Number(day));
}

export {
    getDateAsIsoString,
    parseAppointmentDate,
}
